import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { AppProviders } from '@/app/AppProviders';
import { createRuntime } from '@/app/runtime';
import { AppRoutes } from '@/routes/AppRoutes';
import '@/styles/global.css';

const container = document.getElementById('root');
if (container === null) throw new Error('Falta #root en index.html');

const runtime = createRuntime();

createRoot(container).render(
  <StrictMode>
    <AppProviders runtime={runtime}>
      {/* `basename` sale del `--base` del build (`import.meta.env.BASE_URL`).
          Sin esto, el dashboard servido bajo un prefijo se rompe de la peor
          manera: los assets cargan, la sesión abre, el menú se dibuja… y
          NINGUNA ruta matchea, porque react-router compara `/app/overview`
          contra `/overview`. Todo se ve bien y todo cae en "esa página no
          existe".

          En el dev server `BASE_URL` es `/`, que es exactamente lo que
          react-router espera cuando no hay prefijo. */}
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <AppRoutes />
      </BrowserRouter>
    </AppProviders>
  </StrictMode>,
);
